import { DestroyRef, Directive, ElementRef, inject } from '@angular/core';

@Directive({ selector: '[appPageLoadingOverlay]' })
export class PageLoadingOverlayDirective {
  constructor() {
    const element = inject(ElementRef<HTMLElement>).nativeElement;
    // BlockUI moves its host to body. Ensure root teardown also removes that host.
    inject(DestroyRef).onDestroy(() => element.remove());
  }
}
